import axios from 'axios'
import { toSnakeCase } from 'src/helpers/objectUtils'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  async (request) => {
    request.headers['Auth-Token'] = localStorage.getItem('USER_TOKEN')
    request.data = toSnakeCase(request.data, ['base64_file'])
    request.params = toSnakeCase(request.params, ['base64_file'])

    return request
  },
  (errData) => {
    return errData
  },
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (errData) => {
    if (errData?.response?.status === 401 && !window.location.href.includes('/login')) {
      window.location.href = '/login'
    }

    return Promise.reject(errData)
  },
)

export { axiosInstance }
